function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.6016 11.334C20.229 11.334 25.6016 9.09541 25.6016 6.33398C25.6016 3.57256 20.229 1.33398 13.6016 1.33398C6.97421 1.33398 1.60162 3.57256 1.60162 6.33398C1.60162 9.09541 6.97421 11.334 13.6016 11.334Z",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.6016 11.709C25.6016 14.4702 20.2266 16.709 13.6016 16.709C6.97662 16.709 1.60162 14.4702 1.60162 11.709",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.6016 17.084C25.6016 19.8452 20.2266 22.084 13.6016 22.084C6.97662 22.084 1.60162 19.8452 1.60162 17.084",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.60162 6.28711V22.3821C1.60162 25.1171 6.97662 27.3346 13.6016 27.3346C20.2266 27.3346 25.6016 25.1171 25.6016 22.3821V6.28711",
  stroke: "black",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.714371b0.svg";
export { ForwardRef as ReactComponent };